var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Plotly",
    _vm._g(
      {
        attrs: {
          data: _vm.computedData,
          layout: _vm.computedLayout,
          "display-mode-bar": _vm.displayModeBar,
          displaylogo: false,
          toImageButtonOptions: _vm.toImageButtonOptions,
          "mode-bar-buttons-to-remove": [
            "toggleSpikelines",
            "hoverClosestCartesian",
            "hoverCompareCartesian",
            "select2d",
            "lasso2d",
          ],
        },
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }